// removed by extract-text-webpack-plugin
module.exports = {"pageTitle":"style__pageTitle___3TTpW","col-container":"style__col-container___27uzM","col-title":"style__col-title___7lrl3","require-tag":"style__require-tag___XIAxf","col-input":"style__col-input___1Ed2V"};


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/Block/style.scss
// module id = 1725
// module chunks = 0